<button mat-icon-button type="button" (click)="pauseTask()">
  <mat-icon class="material-symbols-outlined"> pause_circle </mat-icon>
</button>
